import type React from 'react';
import { Select } from '../../../core/Select';
import { useFieldContext } from '../FormContext';

export const SelectField: React.FC = () => {
  const { field, value, onChange } = useFieldContext();

  if (field.type !== 'select') {
    throw new Error('SelectField can only be used with select field type');
  }

  return (
    <div>
      <label className="label" htmlFor={field.name}>
        {field.label}
      </label>
      {field.description && <p className="description">{field.description}</p>}
      <Select
        id={field.name}
        value={value || field.defaultValue || ''}
        options={field.options}
        onChange={onChange}
      />
    </div>
  );
};
